<template>
  <div class="search-filter-header">
    <div class="row">
      <div class="col-8 d-flex align-items-center">
        <div class="multiple-options-selection">
          <div
            class="handler d-flex align-items-center justify-content-between form-control"
            @click.stop="toggleFilterMenu"
          >
            <div class="selected-option-count" v-if="false">
              {{ filter_options.filter((each) => each.selected).length }}
            </div>
            <div class="place-holder">
              {{ filter_options?.find((each) => each.selected)?.label }}
            </div>
            <img
              :src="require(`@/assets/images/icons/chevron-down.svg`)"
              alt="chevron-down"
              :style="{ transform: open_filter_menu ? 'rotate(180deg)' : '' }"
            />
          </div>
          <div
            v-if="open_filter_menu"
            v-click-outside="toggleFilterMenu"
            class="options p-3"
            :style="
              isLangRtl ? 'right: 0px; width: 185px' : 'left: 0px; width: 185px'
            "
          >
            <div
              v-if="false"
              class="option d-flex align-items-center cursor-pointer mb-2 pb-2"
              @click="selectAllFilterOption"
            >
              <input type="checkbox" name="all" :checked="select_all" />
              <div class="ms-2">
                {{ $t("all") }}
              </div>
            </div>
            <div
              v-for="(option, index) in filter_options"
              :key="index"
              :class="
                index < filter_options.length - 1
                  ? 'option d-flex align-items-center cursor-pointer mb-2 pb-2'
                  : 'cursor-pointer'
              "
              @click="selectSingleFilterOption(option)"
            >
              <input
                v-if="false"
                type="checkbox"
                :name="option.key"
                :checked="option.selected"
                class="me-2"
              />
              <div>
                {{ option?.label }}
              </div>
            </div>
            <div
              v-if="false"
              class="d-flex align-items-center cursor-pointer mt-2"
              @click="resetFilterSelection"
            >
              <img
                :src="require('@/assets/images/icons/trash-icon.svg')"
                alt="delete image"
                class="me-2"
              />
              <div>
                {{ $t("reset-selection") }}
              </div>
            </div>
          </div>
        </div>
        <div class="mx-2">
          <base-input
            v-if="
              filter_options?.find((each) => each.selected)?.key === '_id' ||
              filter_options?.find((each) => each.selected)?.key ===
                'created_by' || 
              filter_options?.find((each) => each.selected)?.key === 'referenceNumber'
            "
            cus_style="width:300px"
            :remove_default_margin="true"
            id="reservation-list-search-text"
            placeholder="search-here"
            field="search_text"
            :value="search_text"
            @change-value="setValue"
            @enter="search"
          />
          <base-select
            v-if="
              filter_options?.find((each) => each.selected)?.key === 'client'
            "
            cus_style="width:300px"
            :remove_default_margin="true"
            id="reservation-list-search-text"
            :options="$store.getters['enums/clients_list_enums']"
            field="search_text"
            :value="search_text"
            @change-value="setValue"
          >
          </base-select>
          <base-select
            v-if="
              filter_options?.find((each) => each.selected)?.key === 'category'
            "
            cus_style="width:300px"
            :remove_default_margin="true"
            id="reservation-list-search-text"
            :options="$store.getters['enums/reservation_category_enums']"
            field="search_text"
            :value="search_text"
            @change-value="setValue"
          >
          </base-select>
        </div>
        <div>
          <base-button
            variant="primary"
            id="reservation-list-search-btn"
            @click="search"
          >
            {{ $t("search") }}
          </base-button>
        </div>
      </div>
      <div
        :key="componentKey"
        class="col-4 d-flex justify-content-end align-items-center"
      >
        <div class="d-flex justify-content-end mb-2">
          <div class="d-flex align-items-center flex-wrap">
            <div>
              <base-button
                id="InsuranceCompany-add-btn"
                variant="secondary"
                :cus_style="exportBtnStyle"
                :class="['mt-1 px-4']"
                @click="download"
              >
                {{ $t("export") }}
                <img
                  class="export-icon ms-2"
                  src="@/assets/images/icons/export-icon.svg"
                />
              </base-button>
            </div>
            <div class="mt-1" style="position: relative">
              <base-button
                variant="secondary"
                :class="[
                  'mx-1',
                  {
                    'not-allowed': this.$store.getters[
                      'enums/is_not_permitted'
                    ]('generateReservation'),
                  },
                ]"
                :cus_style="reservationBtnStyle"
                @click="toggleNewReservation"
              >
                <img
                  src="@/assets/images/icons/add-icon.svg"
                  alt="add-icon"
                  class="mx-1"
                />
                <span class="CreateReservation">
                  {{ $t("create-reservation") }}
                </span>
              </base-button>
              <div
                class="reservation-type-options"
                v-if="show_reservation_type_selection"
                v-click-outside="toggleNewReservation"
              >
                <div class="option" @click="redirectNewReservation('charter')">
                  <img
                    class="m-2"
                    :src="require(`@/assets/images/icons/charter-icon.svg`)"
                    alt="charter-icon"
                  />
                  {{ $t("charter-reservation") }}
                </div>
                <div
                  class="option"
                  @click="redirectNewReservation('recurrence')"
                >
                  <img
                    class="m-2"
                    :src="require(`@/assets/images/icons/recurrence-icon.svg`)"
                    alt="recurrence-icon"
                  />
                  {{ $t("recurrence-reservation") }}
                </div>
                <div
                  class="option"
                  @click="redirectNewReservation('shift-recurrence')"
                >
                  <img
                    class="m-2"
                    :src="require(`@/assets/images/icons/shift-recurring-icon.svg`)"
                    alt="recurrence-icon"
                    width="15"
                  />
                  {{ $t("shifts-recurring-sales-order") }}
                </div>
              </div>
            </div>
            <div class="mt-1" v-if="false">
              <base-select
                v-if="selected_tab === 'list'"
                class="searchOption bg-transparent mb-0"
                :options="filterOptions"
                :value="selected_option"
                :small="true"
                @change-value="changeSearchOption"
                :useI18n="true"
              >
              </base-select>
            </div>

            <!-- TODO: SHOW CALENDAR SALES ORDER VIEW WHEN REQUEST BY BUSINESS -->
            <!-- <div class="mt-1 ms-2">
              <img
                class="cursor-pointer"
                :style="`opacity:${selected_tab === 'list' ? 1 : 0.3}`"
                :src="require('@/assets/images/icons/list-icon.svg')"
                alt="list"
                @click.stop="routeToList"
              />
            </div> -->

            <!-- TODO: SHOW CALENDAR SALES ORDER VIEW WHEN REQUEST BY BUSINESS -->
            <!-- <div
              v-if="!showClientIdInfo"
              class="mt-1"
              v-b-tooltip.hover="{
                title: $t('calendar-view'),
                placement: isLangRtl ? 'leftbottom' : 'rightbottom',
                offset: '40',
              }"
            >
              <img
                class="cursor-pointer mx-1"
                :style="`opacity:${selected_tab === 'calendar' ? 1 : 0.3}`"
                :src="require('@/assets/images/icons/calendar-icon.svg')"
                alt="grid"
                @click.stop="routeToCalendar"
              />
            </div> -->
          </div>
        </div>
      </div>
    </div>
    <div class="text-success" v-if="selected_tab === 'list'">
      <hr />
    </div>
    <div class="mb-3" v-if="selected_tab === 'calendar'"></div>
  </div>
</template>

<script>
import { EventBus } from "./event-bus.js";

export default {
  props: ["selected_tab", "showClientIdInfo"],
  emits: ["selectTab", "quickSearch"],
  data() {
    return {
      reservationBtnStyle: `background-color: transparent;padding:6px;color: var(--color-09);font-weight: 600;`,
      exportBtnStyle: `background-color: transparent;padding:6px;font-weight: 600;`,
      componentKey: 0,
      selected_option: null,
      filterOptions: [
        { value: null, text: "bulk-actions" },
        {
          value: "change_status",
          text: "change-status",
        },
      ],
      searchObj: {
        searchOption: "",
        searchText: "",
      },
      show_reservation_type_selection: false,
      search_text: null,
      filter_options: [
        {
          key: "_id",
          label: this.$t("reservation-number"),
          selected: true,
          type: "text",
        },
        {
          key: "client",
          label: this.$t("client"),
          selected: false,
          type: "dropdown",
        },
        {
          key: "created_by",
          label: this.$t("employee-name"),
          selected: false,
          type: "text",
        },
        {
          key: "category",
          label: this.$t("category"),
          selected: false,
          type: "dropdown",
        },
         {
          key: "referenceNumber",
          label: this.$t("reference-number"),
          selected: false,
          type: "text",
        },
      ],
      select_all: false,
      open_filter_menu: false,
    };
  },
  methods: {
    toggleFilterMenu() {
      this.open_filter_menu = !this.open_filter_menu;
    },
    selectAllFilterOption() {
      this.select_all = !this.select_all;
      this.filter_options = this.filter_options?.map((each) => {
        each["selected"] = this.select_all;
        return each;
      });
    },
    selectSingleFilterOption(option) {
      this.toggleFilterMenu();
      this.search_text = null;
      this.filter_options = this.filter_options?.map((each) => {
        if (option.key === each.key) each["selected"] = true;
        else each["selected"] = false;
        return each;
      });
    },
    resetFilterSelection() {
      this.search_text = null;
      this.filter_options = this.filter_options?.map((each) => {
        each["selected"] = false;
        return each;
      });
    },
    setValue(val, field) {
      this[field] = val;
    },
    search() {
      this.$emit(
        "quickSearch",
        this.filter_options?.find((each) => each.selected),
        this.search_text
      );
    },
    redirectNewReservation(type) {
      if (!this.$store.getters["enums/is_not_permitted"]("generateReservation")) {
        let path =  `/reservation/add/form${type ? `?type=${type}` : ""}`
        if (this.$route?.query?.clientID) {
          path += `&clientID=${this.$route?.query?.clientID}`
        }
        this.$router.push(path).catch(() => {});
      }
    },
    toggleNewReservation() {
      this.show_reservation_type_selection =
        !this.show_reservation_type_selection;
    },
    changeSearchOption(option) {
      if (option === "change_status") {
        this.$bvModal.show("update-multi-status");

        this.selected_option = null;
        this.componentKey++;
      } else {
        this.selected_option = option;
      }
    },
    searchMethod() {
      this.$emit("search", this.searchObj);
      EventBus.$emit("search", this.searchObj);
    },
    routeToList() {
      this.$emit("selectTab", "list");
    },
    routeToCalendar() {
      this.$emit("selectTab", "calendar");
    },
    download() {
      this.$emit("showDownloadFilters");
    },
  },
  i18n: {
    messages: {
      en: require("@/services/i18n/locales/en/reservationOperations.json"),
      ar: require("@/services/i18n/locales/ar/reservationOperations.json"),
    },
  },
};
</script>

<style lang="scss">
.search-filter-header {
  .search-input-field {
    font-size: 14px;
    letter-spacing: -0.006em;
    color: var(--color-03);
    max-height: 40px;
  }
  .searchOption {
    select {
      background: transparent;
    }
  }
  .CreateReservation {
    color: var(--color-61);
  }
  .cursor-pointer {
    cursor: pointer;
  }
}
.reservation-type-options {
  position: absolute;
  top: 40px;
  width: 195px;
  z-index: 9999;
  background: var(--color-01);
  border: 1px solid var(--color-14);
  box-shadow: 0px 2px 3px var(--color-38);
  border-radius: 4px;
  .option {
    cursor: pointer;
    padding: 0.4rem;
    font-size: 12px;
    line-height: 20px;
    color: var(--color-02);
  }
  .option:hover {
    background-color: var(--color-23);
    color: var(--color-01);
  }
}
</style>
